import React from 'react';
import { translate } from '../../Services/translation';

const ProductDescription = ({ description }) => {
  return (
    <div className="[ product-specifications__description ] [ text-medium text-large-from-large lh-2 ]">
      <p className="bold text-medium hide-for-large">
        {translate('product-specification.description')}
      </p>
      <div dangerouslySetInnerHTML={{ __html: description }}></div>
    </div>
  );
};

export default ProductDescription;
